
jQuery(function ($) {
    
    jQuery(document).ready(function () {
        $('.categories-dropdown-toggle').on('click', function () {
            console.log($(this).next('.categories-dropdown-menu'))
            $(this).next('.categories-dropdown-menu').toggle();
        });

        // Optional: hide dropdown when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.categories-dropdown').length) {
                $('.categories-dropdown-menu').hide();
            }
        });

    })
});